import { useState } from 'react';
import isMobile from 'ismobilejs';
import { useMediaQuery } from './useMediaQuery';

const MOBILE_QUERY = '(max-width: 768px)';
// Narrower than the layout breakpoint on purpose: a tablet has the room to
// float a dialog over the page it came from, a phone does not.
const SHEET_QUERY = '(max-width: 699px)';

const isPhone = () => typeof window !== 'undefined' && isMobile(window.navigator).phone;

/**
 * Mobile layout kicks in on phone UAs OR narrow viewports. The resolution check
 * catches desktop browsers resized narrow, and lets Playwright viewport tests
 * exercise the mobile branch without UA spoofing.
 */
export function useIsMobileBreakpoint() {
    const [phone] = useState(isPhone);
    const narrow = useMediaQuery(MOBILE_QUERY);
    return phone || narrow;
}

/**
 * Where a dialog takes over the whole screen instead of floating as a centred
 * modal. Every full-screen dialog reads this one hook so they can't disagree
 * about what counts as a phone.
 */
export function useIsSheetLayout() {
    const [phone] = useState(isPhone);
    const narrow = useMediaQuery(SHEET_QUERY);
    return phone || narrow;
}
